<template>
  <div style="display: none" />
</template>

<script>
import { mapGetters } from 'vuex'

import { EventBus } from '@/services/eventbus'

export default {
  name: 'ZeroEmissiezones',
  props: {
    /**
     * Indicates whether the MapBox instance is ready
     */
    loaded: {
      type: Boolean,
      required: true,
    },
    layerVisibility: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      layerName: 'zero_emissiezones',
      type: 'fill',
      minzoom: 10,
      paint: {
        'fill-color': 'rgba(0,200,255,.4)',
        'fill-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0,
          14,
          0.50,
        ],
      },

      textLayout: {
        'symbol-sort-key': 1,
        'symbol-placement': 'point',
        'symbol-z-order': 'source',
        'text-allow-overlap': false,
        'text-field': ['concat', 'Startdatum: ', ['get', 'Startdatum']],
        'text-font': [
          'Open Sans Semibold',
          'Arial Unicode MS Bold',
        ],
        'text-size': 16,
        'text-radial-offset': [ // transition based on zoom
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0,
          14,
          0.50,
        ],
        'text-variable-anchor': ['center'],
        'text-justify': 'auto',
        'visibility': this.layerVisibility ? 'visible' : 'none',
      },
      textPaint: {
        'text-opacity': [
          'interpolate',
          ['linear'],
          ['zoom'],
          10,
          0,
          14,
          0.50,
        ],
      },
      layout: {
        'visibility': this.layerVisibility ? 'visible' : 'none',
      },
    }
  },
  computed: {
    ...mapGetters('deployment', [
      'MapboxAccount',
      'DeploymentLayerName',
    ]),
    source() {
      return {
        url: process.env.VUE_APP_BL_URL || `mapbox://${this.MapboxAccount}.${this.sourceName}`,
        layer: process.env.VUE_APP_BL_SOURCE || this.sourceName,
      }
    },
    sourceName() {
      return this.DeploymentLayerName({ layer: this.layerName })
    },
  },
  watch: {
    loaded: {
      immediate: true,
      handler(loaded) {
        if (!loaded) return

        this.addLayer()
      },
    },
    layerVisibility: {
      handler(visible) {
        !visible ? this.removeLayerAndSource() : this.addLayer()
      },
    },
  },
  methods: {
    /**
     * Add the layer
     */
    addLayer() {
      this.removeLayerAndSource()

      if (! this.sourceName) return

      if (! this.source.url || ! this.source.layer) return

      if (this.$store.map.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName + '-text')
        this.$store.map.removeLayer(this.layerName)
      }

      if (this.$store.map.getSource(this.sourceName)) {
        this.$store.map.removeSource(this.sourceName)
      }

      this.$nextTick(() => {
        this.$store.map.addSource(this.sourceName, {
          type: 'vector',
          url: this.source.url,
        })

        this.$store.map.addLayer({
          'id': this.layerName,
          'type': this.type,
          'source': this.sourceName,
          'source-layer': this.source.layer,
          'minzoom': this.minzoom || 0,
          'paint': this.paint,
          'layout': this.layout,
        })

        this.$store.map.addLayer({
          'id': this.layerName + '-text',
          'type': 'symbol',
          'source': this.sourceName,
          'source-layer': this.source.layer,
          'minzoom': 14,
          'layout': this.textLayout,
          'paint': this.textPaint,
        })

        EventBus.$emit('layers.national.loaded', {
          name: this.layerName,
        })
      })
    },
    removeLayerAndSource () {
      if (this.$store.map.getLayer(this.layerName)) {
        this.$store.map.removeLayer(this.layerName)
        this.$store.map.removeLayer(this.layerName + '-text')
        this.$store.map.removeSource(this.layerName)
      }
    },
  },
}
</script>
